import React from "react";
import {closePopup, getValue} from "../../../static/js/Common2";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import $ from "jquery";
import {pwChange} from "../../../static/js/service/userService";

export default function UserPopupV2(props) {
  let pwChk = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/;
  let getKeepChk = props.data[0];
  let userId = getKeepChk.userId;
  let userType = getKeepChk.userType;
  let token = getKeepChk.token;
  let loginId = props.loginId;

  const btnEvent = () => {
    let currentPw = getValue("currentPassword");
    let newPw1 = getValue("newPassword1");
    let newPw2 = getValue("newPassword2");
    
    if(currentPw.length < 8) {
      alert("현재 비밀번호를 8자리 이상 입력해주세요.");
      return false;
    }
    if(newPw1.length < 8) {
      alert("새 비밀번호는 영문, 숫자, 특수문자 조합으로 8자리 이상 입력해주세요.");
      return false;
    }
    if(newPw2.length < 8) {
      alert("새 비밀번호는 영문, 숫자, 특수문자 조합으로 8자리 이상 입력해주세요.");
      return false;
    }
    if(newPw1 !== newPw2) {
      alert("새 비밀번호가 일치하지 않습니다.");
      return false;
    } else {
      if(!pwChk.test(newPw1)) {
        alert("새 비밀번호는 영문, 숫자, 특수문자 조합으로 8자리 이상 입력해주세요.");
        return false;
      }
    }

    let data = {
      channelType: 2,
      userType: String(userType),
      loginId: loginId,
      currentPassword: currentPw,
      newPassword: newPw1
    }

    pwChange(userId, data, token)
  }

  const closeEvent = () => {
    document.getElementById("currentPassword").value = "";
    document.getElementById("newPassword1").value = "";
    document.getElementById("newPassword2").value = "";

    closePopup("userPopup")
  }

  return (
    <div>
      <div id="userPopup" className='userPopup popupV2 hide'>
        <div className='popupContainer width436'>
          <div className='popupTitle'>
            <h2>비밀번호 변경</h2>
            <button className='closeBtn stopCloseBtn' onClick={() => closeEvent()}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <form className='popupContent shopChoiceBox'>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>현재 비밀번호</div>
              <div className='flexContent'>
                <input id='currentPassword' name='currentPassword' type='password' maxLength={16} autoComplete="off" />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>새 비밀번호</div>
              <div className='flexContent'>
                <input id='newPassword1' name='newPassword1' type='password' maxLength={16} autoComplete="off" />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>새 비밀번호 확인</div>
              <div className='flexContent'>
                <input id='newPassword2' name='newPassword2' type='password' maxLength={16} autoComplete="off" />
              </div>
            </div>
            <p>※ 비밀번호는 영문, 숫자, 특수문자 조합으로 8자리 이상 입력해주세요.</p>
          </form>
          <div className='popupBtn'>
            <button type='button' className='closeBtn' onClick={() => closeEvent()}>닫기</button>
            <button type='button' className='blueBtn' onClick={() => btnEvent()}>확인</button>
          </div>
        </div>
      </div>
    </div>
  )
}